<template>
  <div class="login-container">
    <!-- Background Design -->
    <div class="login-background">
      <div class="background-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <!-- Main Login Card -->
    <div class="login-card-wrapper">
      <div class="login-card">
        <!-- SOULMAINT Logo Header -->
        <div class="login-header">
          <div class="logo-container">
            <img src="/s.png" alt="SOULMAINT" class="main-logo" />
            <h1 class="brand-title">SOULMAINT</h1>
          </div>
          <p class="welcome-text">Maintenance Management System</p>
        </div>

        <!-- Login Form -->
        <form @submit.prevent="handleLogin" class="login-form">
          <div class="form-group">
            <label class="form-label">Username</label>
            <div class="input-group">
              <span class="input-icon">👤</span>
              <input 
                type="text" 
                v-model="credentials.username" 
                class="form-control"
                required 
                :disabled="loading"
                placeholder="Enter your username"
              >
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">Password</label>
            <div class="input-group">
              <span class="input-icon">🔒</span>
              <input 
                type="password" 
                v-model="credentials.password" 
                class="form-control"
                required 
                :disabled="loading"
                placeholder="Enter your password"
              >
            </div>
          </div>
          
          <button 
            type="submit" 
            class="login-btn"
            :disabled="loading"
            :class="{ 'loading': loading }"
          >
            <span v-if="!loading">Sign In</span>
            <div v-else class="btn-spinner"></div>
          </button>
          
          <div v-if="error" class="alert alert-error">
            <span class="error-icon">⚠️</span>
            {{ error }}
          </div>
        </form>

        <!-- Demo Accounts -->
        <!-- <div class="demo-section">
          <div class="demo-header">
            <span class="demo-icon">💡</span>
            <h4>Demo Accounts</h4>
          </div>
          <div class="demo-accounts">
            <div class="demo-account">
              <strong>Admin Account:</strong>
              <span>admin / admin123</span>
            </div>
            <div class="demo-account">
              <strong>User Account:</strong>
              <span>user / user123</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Footer -->
    <div class="login-footer">
      <div class="footer-content">
        <!-- Company Logo -->
        <div class="company-brand">
          <img src="/logo.png" alt="Soulintec" class="company-logo" />
          <span class="company-name">Soulintec</span>
        </div>
        
        <!-- Developer Credit -->
        <div class="developer-credit">
          <span>Developed by Soulintec Digitalization Team © 2025</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loading: false,
      error: ''
    }
  },
  
  methods: {
    async handleLogin() {
      this.loading = true;
      this.error = '';
      
      try {
        console.log('🔐 Starting login process...');
        const result = await this.$store.dispatch('auth/login', this.credentials);
        console.log('🎉 Login successful, redirecting...', result);
        
        // انتظر شوية علشان التأكد إن الـ state اتحدث
        setTimeout(() => {
          this.$router.push('/');
        }, 100);
        
      } catch (error) {
        console.error('💥 Login failed:', error);
        this.error = error.message || 'Login failed. Please check your credentials and try again.';
      } finally {
        this.loading = false;
      }
    }
  },
  
  mounted() {
    // لو المستخدم مسجل دخول خلاص، ابعته للـ dashboard
    if (this.$store.getters['auth/isAuthenticated']) {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #008cff 0%, #0012b3c0 100%);
  position: relative;
  overflow: hidden;
  padding: 20px;
}

/* Background Design */
.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.background-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.shape-1 {
  width: 300px;
  height: 300px;
  top: -150px;
  right: -100px;
}

.shape-2 {
  width: 200px;
  height: 200px;
  bottom: -50px;
  left: -50px;
}

.shape-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  right: 20%;
}

/* Main Login Card */
.login-card-wrapper {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 440px;
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 40px;
  backdrop-filter: blur(10px);
}

/* Header */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
}

.main-logo {
  height: 50px;
  width: auto;
}

.brand-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #c03421, #d42828);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-text {
  color: #7f8c8d;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 500;
}

/* Form Styles */
.login-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 25px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.95rem;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  z-index: 2;
  font-size: 1.1rem;
}

.form-control {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.form-control:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-control:disabled {
  background: #f8f9fa;
  opacity: 0.7;
}

/* Login Button */
.login-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #c03421, #d42828);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-btn.loading {
  color: transparent;
}

.btn-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

/* Error Alert */
.alert-error {
  background: #ffeaa7;
  color: #e17055;
  padding: 12px 15px;
  border-radius: 8px;
  margin-top: 20px;
  border-left: 4px solid #fdcb6e;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-icon {
  font-size: 1.2rem;
}

/* Demo Section */
.demo-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  border-left: 4px solid #3498db;
}

.demo-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.demo-icon {
  font-size: 1.2rem;
}

.demo-header h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 1rem;
}

.demo-accounts {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.demo-account {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.demo-account:last-child {
  border-bottom: none;
}

.demo-account strong {
  color: #2c3e50;
  font-size: 0.9rem;
}

.demo-account span {
  color: #7f8c8d;
  font-size: 0.85rem;
  font-family: 'Courier New', monospace;
}

/* Footer */
.login-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 15px 20px;
  z-index: 3;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.company-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.company-logo {
  height: 30px;
  width: auto;
  opacity: 0.9;
}

.company-name {
  color: white;
  font-weight: 600;
  font-size: 1rem;
}

.developer-credit {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-container {
    padding: 15px;
  }

  .login-card {
    padding: 30px 25px;
  }

  .brand-title {
    font-size: 2rem;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .demo-account {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .shape-1, .shape-2, .shape-3 {
    display: none;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 25px 20px;
  }

  .logo-container {
    flex-direction: column;
    gap: 10px;
  }

  .brand-title {
    font-size: 1.8rem;
  }

  .form-control {
    padding: 12px 12px 12px 40px;
  }
}
</style>